import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
import SysUtils from '@/base/utils/SysUtils'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.FIND_PURCHASE = function (state, payload) {
  state.p_detail = payload
}
mutations.FIND_CHAT = function (state, payload) {
  state.chat_rows = payload
}

const state = {
  rows: [],
  row: {},
  condition: {},
  p_detail: [],
  chat_rows: []
}
const actions = {
  init: ({ commit, state }) => {

  },
  reset: ({ commit, state }) => {
    console.debug('called reset')
    commit('FIND_ALL', '')
  },
  cancel: ({ commit, state }) => {
    console.debug('called M0004Purchase cancel')
    commit('EDIT', null)
  },
  search: ({ commit, state }, condition) => {
    console.debug('called M0002LandingPage search')
    return client.postData({ data: { search: { api: 'M0004PurchaseMasterService.searchData', input: condition } } })
      .then((data) => {
        if (SysUtils.isEmpty(data.search.output)) {
          alert('no match record')
        }
        commit('FIND_ALL', data.search.output)
      })
  },
  searchPurchase: ({ commit, state }, condition) => {
    console.debug('called M0004Purchase search')
    return client.postData({ data: { searchPurchase: { api: 'M0004PurchaseMasterService.searchPurchase', input: condition } } })
      .then((data) => {
        commit('FIND_ALL', data.searchPurchase.output)
      })
  },
  viewPurchase: ({ commit, state }, condition) => {
    console.debug('called M0004Purchase search')
    return client.postData({ data: { viewPurchase: { api: 'M0004PurchaseMasterService.viewPurchase', input: condition } } })
      .then((data) => {
        data.viewPurchase.output.pm_rows.files = {}
        commit('FIND_PURCHASE', data.viewPurchase.output)
      })
  },
  submitRequest: ({ commit, state }, condition) => {
    console.debug('called M0004Purchase submitRequest')
    return client.postData({ data: { submitRequest: { api: 'M0004PurchaseMasterService.submitRequest', input: condition } } })
      .then((data) => {
        commit('FIND_PURCHASE', data.submitRequest.output)
      })
  },
  setPrice: ({ commit, state }, condition) => {
    console.debug('called M0004Purchase setPrice')
    return client.postData({ data: { setPrice: { api: 'M0004PurchaseMasterService.setPrice', input: condition } } })
      .then((data) => {
        commit('FIND_PURCHASE', data.setPrice.output)
      })
  },
  add: ({ commit, state }) => {
    console.debug('called M0004Purchase add')
    commit('EDIT',
      {
        id: null,
        files: {}
        // relates: {},
        // belongs: {}
      }
    )
  },
  edit: ({ commit, state }, id) => {
    console.debug('called M0004Purchase edit')
    return client.postData({ data: { find: { api: 'M0004PurchaseMasterService.getData', input: {id: id, ':detail': 1} } } })
      .then((data) => {
        commit('EDIT', data.find.output)
      })
  },
  delete: ({ commit, state }, row) => {
    console.debug('called M0004Purchase delete')
    return client.postData({ data: { delete: { api: 'M0004PurchaseMasterService.deleteData', input: row } } })
      .then((data) => {
        commit('EDIT', null)
      })
  },
  save: ({ commit, state }, row) => {
    console.debug('called M0004Purchase save')
    return client.postData({ data: { save: { api: 'M0004PurchaseMasterService.saveData', input: row } } })
      .then((data) => {
        commit('SAVE', data.save.output)
      })
  },
  downloadCsv: ({ commit, state }, condition) => {
    console.debug('called M0004Purchase download')
    return client.download({ data: { download: { api: 'M0004PurchaseMasterService.downloadData', input: condition } } })
  }
}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module
